import { Landmark } from "lucide-react";
import { useBranding, logoUrl } from "@/lib/branding";

const DOTS = Array.from({ length: 22 }, (_, i) => ({
  left: `${(i * 37) % 100}%`, size: 2 + (i % 3), delay: `${(i * 1.7) % 18}s`, dur: `${18 + (i % 7) * 3}s`,
}));

export const Ambient = () => (
  <div className="fixed inset-0 overflow-hidden pointer-events-none z-0 print:hidden" aria-hidden="true">
    <div className="ambient-anim absolute -top-40 -left-32 w-[560px] h-[560px] rounded-full blur-3xl opacity-40 dark:opacity-50"
      style={{ background: "radial-gradient(circle, rgba(35,72,214,.55), transparent 65%)", animation: "drift 22s ease-in-out infinite" }} />
    <div className="ambient-anim absolute top-1/3 -right-40 w-[520px] h-[520px] rounded-full blur-3xl opacity-30 dark:opacity-35"
      style={{ background: "radial-gradient(circle, rgba(212,175,55,.5), transparent 65%)", animation: "drift 28s ease-in-out infinite reverse" }} />
    <div className="ambient-anim absolute -bottom-52 left-1/3 w-[620px] h-[620px] rounded-full blur-3xl opacity-25 dark:opacity-40"
      style={{ background: "radial-gradient(circle, rgba(56,189,248,.45), transparent 65%)", animation: "drift 32s ease-in-out infinite" }} />
    {DOTS.map((d, i) => (
      <span key={i} className="ambient-anim absolute bottom-[-10px] rounded-full bg-sky-400/50 dark:bg-amber-200/60"
        style={{ left: d.left, width: d.size, height: d.size, animation: `floatUp ${d.dur} linear ${d.delay} infinite` }} />
    ))}
  </div>
);

export const BrandMark = ({ size = "w-10 h-10", testid }) => {
  const b = useBranding();
  if (b.has_logo) return <img src={logoUrl(b)} alt={b.name} className={`${size} object-contain rounded-lg bg-white/90 p-0.5`} data-testid={testid} />;
  return (
    <div className={`${size} rounded-lg grid place-items-center icon-3d`} style={{ "--c1": "#D4AF37", "--c2": "#7A5A0E" }} data-testid={testid}>
      <Landmark className="w-1/2 h-1/2 text-white drop-shadow" />
    </div>
  );
};

export const BrandLoader = ({ label = "Loading secure workspace" }) => (
  <div className="h-[60vh] grid place-items-center" data-testid="app-loading">
    <div className="flex flex-col items-center gap-4">
      <div className="relative w-14 h-14">
        <div className="absolute inset-0 rounded-full border-2 border-sky-400/20" />
        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-amber-400 border-r-sky-400" style={{ animation: "spinRing 1s linear infinite" }} />
        <div className="absolute inset-3"><BrandMark size="w-8 h-8" /></div>
      </div>
      <div className="text-xs uppercase tracking-[0.25em] text-slate-500">{label}</div>
    </div>
  </div>
);
